import React from 'react';
import ReactDom from 'react-dom';
//
import Component from '../core/component';
//
import tools from '../libs/tools';
import debug from 'debug'
import $ from "jquery";

const log = debug('mobile.directive')
let showDom = null;


class Directive extends Component {
    state = {};
    
    constructor(props) {
        super(props);
        if (!showDom) {
            showDom = $(`<div id="${tools.uuid()}"></div>`)[0];
            $(document.body).append(showDom)
        }
    }
    
    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {
    }
    
    /**
     *
     * @return {{$$typeof, key, children, containerInfo, implementation}}
     */
    render() {
        return ReactDom.createPortal(this.props.children, showDom);
    }
}

export default Directive;

